import useFetchObjects from "../../api/useFetchObjects";

const useSubscriptionPlans = () => {
  return useFetchObjects(["subscription-plans"], "subscriptions/", null, {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    onError: (error) => {
      return {
        message: error?.message || "Failed to load subscription plans",
      };
    },
  });
};

export default useSubscriptionPlans;
